// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'

import attendance from '@src/views/apps/humanresource/store/DTR'
import customer from '@src/views/apps/customer/store'
import productService from '@src/views/apps/product/store'
import prodSvcCategory from '@src/views/apps/product/store/prodSvcCategory'
import prodSvcUOM from '@src/views/apps/product/store/prodSvcUOM'
import prodSvcTax from '@src/views/apps/product/store/prodSvcTaxGroup'
import vendor from '@src/views/apps/vendor/store'
import invoice2 from '@src/views/apps/accounting/store'
import acctgCOA from '@src/views/apps/accounting/store/COA'
import bankingAccount from '@src/views/apps/accounting/store/bankingAccount'
import bankingTransfer from '@src/views/apps/accounting/store/bankingTransfer'

const rootReducer = {
  auth,
  navbar,
  layout,

  attendance,
  customer,
  productService,
  prodSvcCategory,
  prodSvcUOM,
  prodSvcTax,
  vendor,
  invoice2,
  acctgCOA,
  bankingAccount,
  bankingTransfer
}

export default rootReducer
